import React from 'react';
import { IMPACT_LABELS, CONTROL_LABELS } from '../../constants/complianceOptions';

interface ComplianceDetailsProps {
  isSox: boolean;
  annualFinancialImpact: string;
  soxControlTypes?: string[];
  complianceSubmittedBy: string;
  complianceSubmittedAt: string;
}

const ComplianceDetails: React.FC<ComplianceDetailsProps> = ({
  isSox,
  annualFinancialImpact,
  soxControlTypes,
  complianceSubmittedBy,
  complianceSubmittedAt,
}) => {
  const controlLabels = soxControlTypes && soxControlTypes.length > 0
    ? soxControlTypes.map(c => CONTROL_LABELS[c] || c).join(', ')
    : 'None';

  const formattedDate = complianceSubmittedAt
    ? new Date(complianceSubmittedAt).toLocaleString()
    : 'N/A';

  return (
    <div className="compliance-details" style={{ padding: '16px', border: '1px solid #d5dbdb', borderRadius: '8px', backgroundColor: '#f9f9f9', marginBottom: '16px' }}>
      <h4 style={{ marginTop: 0, marginBottom: '12px' }}>SOX Compliance Details</h4>

      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
        <span style={{ fontWeight: 600, marginRight: '8px' }}>Classification:</span>
        <span style={{
          padding: '2px 10px',
          borderRadius: '4px',
          fontSize: '13px',
          fontWeight: 600,
          backgroundColor: isSox ? '#fce4e4' : '#e3fcef',
          color: isSox ? '#d13212' : '#1d8102',
        }}>
          {isSox ? 'SOX' : 'Non-SOX'}
        </span>
      </div>

      <div style={{ marginBottom: '6px' }}>
        <span style={{ fontWeight: 600 }}>Annual Financial Impact: </span>
        {IMPACT_LABELS[annualFinancialImpact] || annualFinancialImpact}
      </div>

      <div style={{ marginBottom: '6px' }}>
        <span style={{ fontWeight: 600 }}>SOX Controls: </span>
        {controlLabels}
      </div>

      <div style={{ marginBottom: '6px' }}>
        <span style={{ fontWeight: 600 }}>Submitted By: </span>
        {complianceSubmittedBy}
      </div>

      <div>
        <span style={{ fontWeight: 600 }}>Submitted At: </span>
        {formattedDate}
      </div>
    </div>
  );
};

export default ComplianceDetails;
